<template>
<RouterLink
  :to="{ ...item }" 
  :class="[
    'group flex gap-3 rounded-md px-2 py-2.5 sm:py-2 font-medium text-base/6 sm:text-sm/5 items-center hover:bg-secondary/5 text-slate-400',
    { 'bg-secondary/5 text-white': isActive },
    { 'px-3': iconsOnly },
  ]"
  @click="onItemClicked(item)"
>
  <component 
    :is="item.icon"
     v-if="item.icon" 
     class="h-5 w-5 shrink-0" 
     aria-hidden="true" 
    />
  <span 
    v-else-if="item.iconClass" 
    :class="[item.iconClass, 'h-5 w-5 shrink-0']"
     aria-hidden="true" 
  />

  <span v-if="!iconsOnly">{{ item.label }}</span>
</RouterLink>
</template>

<script lang="ts" setup>
import { PropType, computed } from 'vue'
import { RouterLink, useRouter } from 'vue-router'

export type NavItemType = {
  name: string
  label: string
  href: string
  icon?: any
  iconClass?: string
  children?: NavItemType[]
  params?: Record<string, any>,
  command?: () => void
}
const props = defineProps({
  iconsOnly: {
    type: Boolean,
    default: false
  },
  item: {
    type: {} as PropType<NavItemType>,
    required: true
  }
})

const router = useRouter()
const isActive = computed(() => {
  const matchedName = router.currentRoute.value.name === props.item.name
  const matchedPath = props.item.href == '/' ? false : router.currentRoute.value.path.includes(props.item.href)

  return matchedName || matchedPath
})

const onItemClicked = (item: NavItemType) => {
  if (item.command) {
    item.command()
  }
}
</script>